import { ShortDateFormats, DecimalFormats, GroupDelimiter } from '@zooz/localize'

export const PRIMARY_LANGUAGE_CODE = 'en-US'
export const DEFAULT_SHORT_DATE_FORMAT = ShortDateFormats['dd-mm-yyyy']
export const DEFAULT_DECIMAL_NUMBER_FORMAT = DecimalFormats.Dot
export const DEFAULT_GROUP_NUMBER_DELIMITER = GroupDelimiter.Comma
export const DISMISS_LOCALSTORAGE_KEY = 'languagesDismissed'
export const DEFAULT_CACHING_TRANSLATIONS_TTL = 300000 // 5 minutes
